import { useContext } from 'react';

import MainLayoutContext from './MainLayoutContext';

const useMainLayout = () => {
  const context = useContext(MainLayoutContext);

  return context;
};

export default useMainLayout;
